import { notEqual, Permission } from 'shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Target } from '../TargetsContext/types'
import CreateEditFormItems from '../components/CreateEditFormItems'
import { CreateEditFormItemsValues } from '../components/CreateEditFormItems/types'
import { useTargetsContext } from '../TargetsContext'

export function useEdit(): EditRowActionOptions<
  Target,
  CreateEditFormItemsValues
> {
  const { refetch, edit } = useTargetsContext()
  return {
    permission: Permission.EditLIMSAsphaltMixDesignTarget,
    modal: {
      type: 'simple',
      recordName: 'name',
      initialValues: ({ percentages, name, description }) => ({
        name,
        description,
        percentages: percentages.map(
          ({
            mixDesign: { globalId: mixDesignId, mixDesignNumber },
            percentage,
          }) => ({
            mixDesignId,
            mixDesignNumber,
            percentage,
          })
        ),
      }),
      body: <CreateEditFormItems />,
      onOk: async (
        { id, name, description, ...record },
        { percentages, ...values }
      ) => {
        if (
          values.name === name &&
          values.description === description &&
          !notEqual(
            record.percentages.map(
              ({ mixDesign: { globalId: mixDesignId }, percentage }) =>
                `${mixDesignId}-${percentage}`
            ),
            (percentages ?? []).map(
              ({ mixDesignId, percentage }) => `${mixDesignId}-${percentage}`
            )
          )
        )
          return
        await edit({
          id,
          percentages: percentages?.map(({ mixDesignId, percentage }) => ({
            mixDesignId,
            // Required field so using bang
            percentage: percentage!,
          })),
          ...values,
        })
        refetch()
      },
    },
  }
}
